import React, { useEffect, useState } from 'react';

import { adminApi } from '../../api';

import { useAlerts } from '../../components/context';
import KYCFlowForm from '../../components/applications/KYCFlowForm';
import KYCFlowList from '../../components/applications/KYCFlowList';
import ConfirmationModal from '../../components/common/ConfirmationModal';
import Loader from '../../components/common/Loader';

export default function AdminKYCFlow({ appHandle, frozen, t }) {
  const [isEditing, setIsEditing] = useState(false);
  const [options, setOptions] = useState({});
  const [optionsLoaded, setOptionsLoaded] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [flows, setFlows] = useState({});
  const [selectedFlow, setSelectedFlow] = useState({});
  const [flowToSubmit, setFlowToSubmit] = useState('');
  const [approvalStatus, setApprovalStatus] = useState('');

  const { setAlert } = useAlerts();

  const clearFlow = () => {
    setSelectedFlow({});
  };

  const handleSelectFlow = (flow) => {
    setIsEditing(false);
    setSelectedFlow(flow);
  };

  const evaluateKYCFlow = async (uuid, approved) => {
    try {
      const response = await adminApi.evaluateKYCFlow(uuid, approved);
      const { flow } = response;
      const updatedFlows = { ...flows };
      updatedFlows[flow.uuid] = flow;
      setFlows(updatedFlows);
      setAlert({ message: response.message, variant: 'success' });
    } catch (error) {
      setAlert({ message: error, variant: 'warning' });
    }
    setFlowToSubmit('');
  };

  useEffect(() => {
    const fetchKYCOptions = async () => {
      try {
        const response = await adminApi.fetchKYCFlowOptions(appHandle);
        setOptions(response.options);
      } catch (error) {
        setAlert({ message: error, variant: 'warning' });
      }
      setOptionsLoaded(true);
    };

    fetchKYCOptions();
  }, []);

  useEffect(() => {
    const getFlows = async () => {
      setLoaded(false);
      try {
        const response = await adminApi.fetchKycFlows(appHandle);
        setFlows(response.kyc_flows);
      } catch (error) {
        setAlert({ message: error, variant: 'warning' });
      }
      setLoaded(true);
    };

    getFlows();
  }, []);

  if (!loaded && !optionsLoaded) return <Loader />;

  return (
    <>
      <KYCFlowForm
        flow={selectedFlow}
        options={options}
        clear={clearFlow}
        setCreateFlow={() => {}}
        editFlow={() => {}}
        deleteFlow={() => {}}
        setIsEditing={() => {}}
        isEditing={false}
        isCreate={false}
        readonly
      />

      <KYCFlowList
        flows={flows}
        t={t}
        handleSelectFlow={handleSelectFlow}
        setFlowToSubmit={setFlowToSubmit}
        setApprovalStatus={setApprovalStatus}
        readonly={frozen}
      />

      {flowToSubmit && (
        <ConfirmationModal
          show={flowToSubmit !== ''}
          title="Approve KYCFlow"
          message={t('applications.kycFlows.evaluateApprovalMessage', {
            uuid: flowToSubmit,
            status: approvalStatus ? t('common:buttons.approved') : t('common:buttons.declined'),
          })}
          buttonLabel={t('common:buttons.submit')}
          buttonLoadingLabel={t('common:status.submitting')}
          buttonVariant="warning"
          onHide={() => setFlowToSubmit('')}
          handleSubmit={() => evaluateKYCFlow(flowToSubmit, approvalStatus)}
          setShow={setFlowToSubmit}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
        />
      )}
    </>
  );
}
